
    import { createApp } from 'vue';
    import App from '@/App.vue';
    import router from '@/router';
    import 'animate.css';

     const app = createApp(App);
     if (window.hwerrVue) {
  app.config.errorHandler = window.hwerrVue;
}
    app.use(router).mount('#app');
    